import {Edge, Node} from '@xyflow/react';
import {ERFEdge, ERFElement, TRFEdgeDataConfig, TRFWorkZoneDataConfig} from '@progress-fe/rf-core';
import {v4 as uuidv4} from 'uuid';

export const ELEMENTS_SAMPLE_WORKZONE_LIST: {
  projectId: string;
  projectName: string;
  nodes: Node<TRFWorkZoneDataConfig, ERFElement>[];
  edges: Edge<TRFEdgeDataConfig>[];
}[] = [
  {
    projectId: '47CB2F0C-0000-0000-0000-000000000000',
    projectName: 'Элементы (моковый проект)',
    nodes: [
      {
        id: '196C89E0-1111-0000-0000-000000000001', // H-100
        type: ERFElement.Heater, // heater
        data: {
          title: 'H-100',
          templateCode: 'default'
        },
        position: {x: 0, y: 0},
        connectable: true,
        deletable: true
      },
      {
        id: '196C89E0-1111-0000-0000-000000000002', // H-101
        type: ERFElement.Heater, // heater
        data: {
          title: 'H-101',
          templateCode: 'default'
        },
        position: {x: 360, y: 0},
        connectable: true,
        deletable: true
      },
      {
        id: '196C89E0-1111-0000-0000-000000000003',
        type: ERFElement.Pipeline,
        data: {
          title: 'P-100',
          templateCode: 'default'
        },
        position: {x: 0, y: 250},
        connectable: true,
        deletable: true
      },
      {
        id: '196C89E0-2222-2222-2222-000000000001', // F-100
        type: ERFElement.Function, // function
        data: {
          title: 'F-100',
          templateCode: 'default'
        },
        position: {x: 120, y: 90},
        connectable: true,
        deletable: true
      },
      {
        id: '196C89E0-2222-2222-2222-000000000002', // А-100
        type: ERFElement.Optimization, // optimization
        data: {
          title: 'А-100',
          templateCode: 'default'
        },
        position: {x: 250, y: 90},
        connectable: true,
        deletable: true
      }
    ],
    edges: [
      {
        id: uuidv4(),
        type: ERFEdge.Logical, // logical
        source: '196C89E0-1111-0000-0000-000000000001', // H-100
        target: '196C89E0-2222-2222-2222-000000000001', // F-100
        sourceHandle: 'source_logical_flow',
        targetHandle: 'target_logical_flow',
        deletable: false // !!!
      },
      {
        id: uuidv4(),
        type: ERFEdge.Logical, // logical
        source: '196C89E0-2222-2222-2222-000000000001', // F-100
        target: '196C89E0-2222-2222-2222-000000000002', // A-100
        sourceHandle: 'source_logical_flow',
        targetHandle: 'target_logical_flow',
        deletable: false // !!!
      },
      {
        id: uuidv4(),
        type: ERFEdge.Logical, // logical
        source: '196C89E0-2222-2222-2222-000000000002', // A-100
        target: '196C89E0-1111-0000-0000-000000000002', // H-101
        sourceHandle: 'source_logical_flow',
        targetHandle: 'target_logical_flow',
        deletable: false // !!!
      }
    ]
  }
];
